export const ACTUAL_PRICE = 799;

export const SERVICE_HISTORY_SAMPLE_REPORT_URL = "https://media.cars24.com/cars24/car-health-report/vhr/VHR-Sample-Report-CARS24.pdf";

export const vhrEvents = {
    event: "vas_vhr_flow",
    eventCategory: "vas_vhr_flow"
};

export const vhrEventNames = {
    HOMEPAGE_SAMPLE_REPORT_CTA_CLICKED: "landing_page_sample_report_cta_clicked",
    HOMEPAGE_SAMPLE_REPORT_BRAND_SELECTED: "landing_page_sample_report_make_selected",
    FAQ_CLICKED: "faq_clicked",
    PROSPECT_LEAD_CREATED: "prospect_lead_created",
    LANDED_ON_CART_PAGE: "landed_cart_page",
    DELIVERY_OPTIONS_VISIBLE: "delivery_options_visible",
    EXPRESS_OPTION_TOGGLED: "express_option_toggle",
    CART_PAGE_SAMPLE_REPORT_CLICKED: "cart_sample_report_clicked",
    PAY_NOW_CLICKED: "pay_now_clicked",
    DELIVERY_SELECTED: "delivery_selected",
    ORDER_CREATED: "vas_vhr_order_placed",
    VRN_ENTERED: "vrn_entered",
    GET_REPORT_CLICKED: "get_report_clicked",
    SAMPLE_CAROUSEL_SCROLL: "sample_carousel_scroll",
    DELIVERY_REFUND_DETAILS_CLICKED: "refund_details_express_delivery",
    REPORT_REFUND_DETAILS_CLICKED: "refund_details_vhr_report",
    DOWNLOAD_REPORT_CLICKED: "download_report",
    DOWNLOAD_INVOICE_CLICKED: "download_invoice",
    LP_REG_BOX_CLICKED: "lp_reg_no_box_clicked",
    LOGIN_DONE: "login_done",
    LANDED_ON_MANUAL_PAGE: "landed_select_manual_make",
    MANUAL_MAKE_SELECTED: "manual_make_selected",
    MANUAL_MODEL_SELECTED: "manual_model_selected",
    FETCH_LEAD_FAILURE: "fetch_lead_failure"
};
